// OR Seed Finder — фильтрация паков по зоне/свету/месту/целям, тайминг посадки,
// ZIP→зона (phzmapi.org), Klaviyo event "Requested Seed Plan", .ics с датами.
// Карточки отрендерены сервером (or-seed-finder.liquid), тут только показ/скрытие.
(function () {
    'use strict';

    if (window.orSeedFinderInit) return;
    window.orSeedFinderInit = true;

    // Средние даты заморозков по зонам USDA: [последний весенний, первый осенний].
    // Зона 6 сверена с утверждённым прототипом (Apr 18 / Oct 15). 10+ — без заморозков.
    var FROST = {
        3: ['May 30', 'Sep 8'],
        4: ['May 20', 'Sep 22'],
        5: ['May 5', 'Oct 5'],
        6: ['Apr 18', 'Oct 15'],
        7: ['Apr 5', 'Oct 25'],
        8: ['Mar 20', 'Nov 10'],
        9: ['Mar 1', 'Nov 25'],
        10: null,
        11: null
    };
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function toDate(str) { // 'Apr 18' → Date текущего года
        var p = str.split(' ');
        return new Date(new Date().getFullYear(), MONTHS.indexOf(p[0]), parseInt(p[1], 10));
    }
    function addDays(d, n) {
        var r = new Date(d.getTime());
        r.setDate(r.getDate() + n);
        return r;
    }
    function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
    function rollForward(d) { // прошедшая дата бесполезна для напоминания — переносим на следующий год
        // сравниваем с местной полуночью: в сам день посева дата ещё актуальна
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        if (d.getTime() < today.getTime()) d.setFullYear(d.getFullYear() + 1);
        return d;
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    // YYYY-MM-DD из локальных компонент: toISOString уводит на день назад восточнее UTC
    function isoDay(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function icsDay(d) { return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()); }
    function icsEsc(s) { return String(s).replace(/\\/g, '\\\\').replace(/[,;]/g, '\\$&').replace(/\n/g, '\\n'); }

    // Тайминг и сезонный чип карточки для выбранной зоны
    function timingFor(zone, ds) {
        var frost = FROST[zone];
        var gs = ds.gs || 'any';
        var isFlower = ds.goals.indexOf('flower') !== -1;
        var isPerennial = ds.life.indexOf('perennial') !== -1 && ds.life.indexOf('annual') === -1;

        if (gs === 'indoor') {
            return { html: '<strong>Grow indoors year-round.</strong> Harvest in 1 to 3 weeks.', chip: 'indoors', dot: 'indoor' };
        }
        if (!frost) {
            if (gs === 'cool') return { html: '<strong>Frost-free zone:</strong> sow in your cool season, fall through early spring.', chip: 'cool season', dot: 'cool' };
            return { html: '<strong>Frost-free zone:</strong> plant nearly year-round, avoid peak summer heat.', chip: gs === 'warm' ? 'warm season' : 'sow anytime', dot: 'warm' };
        }

        var lf = frost[0];
        var indoors = fmt(addDays(toDate(lf), -42));
        // Осенний посев холодных культур: ~8 недель до первого заморозка,
        // чтобы успели вырасти (за 10 дней до заморозка сеять поздно)
        var fallDate = addDays(toDate(frost[1]), -56);
        var fallSow = fmt(fallDate);

        if (isPerennial && isFlower) {
            return { html: '<strong>Sow after ' + lf + ',</strong> or in fall to bloom next year.', chip: 'perennial', dot: 'cool' };
        }
        if (isFlower) {
            return { html: '<strong>Sow after your last frost (~' + lf + '),</strong> once soil is warm.', chip: 'sow after frost', dot: 'cool' };
        }
        if (gs === 'warm') {
            return { html: '<strong>Start indoors ~' + indoors + '.</strong> Transplant after your last frost near ' + lf + '.', chip: 'warm season', dot: 'warm' };
        }
        if (gs === 'cool') {
            // Ближайшее к сегодня окно посева — первым
            var springNext = rollForward(toDate(lf));
            var fallNext = rollForward(new Date(fallDate.getTime()));
            if (fallNext < springNext) {
                return { html: '<strong>Sow ~' + fallSow + ' for a fall harvest.</strong> In spring: direct-sow around ' + lf + '.', chip: 'cool season', dot: 'cool' };
            }
            return { html: '<strong>Direct-sow around ' + lf + '.</strong> Sow again ~' + fallSow + ' for fall.', chip: 'cool season', dot: 'cool' };
        }
        return { html: '<strong>Cool crops:</strong> sow near ' + lf + '. <strong>Warm crops:</strong> start indoors ~' + indoors + '.', chip: 'sow after frost', dot: 'mixed' };
    }

    // Даты-действия для напоминаний/.ics (прошедшие переносятся на следующий год).
    // Ветки зеркалят timingFor: indoor → цветы → warm/cool/any, иначе календарь
    // противоречит тексту карточки.
    function actionDates(zone, ds) {
        var frost = FROST[zone];
        if (ds.gs === 'indoor') return [];
        var out = [];
        if (!frost) {
            // Безморозная зона: холодным культурам — старт прохладного сезона (~Oct 1)
            if (ds.gs === 'cool' || ds.gs === 'any') {
                out.push({ label: 'Cool-season sowing: ' + ds.title, date: rollForward(new Date(new Date().getFullYear(), 9, 1)) });
            }
            return out;
        }
        var lf = toDate(frost[0]);
        if (ds.goals.indexOf('flower') !== -1) {
            out.push({ label: 'Sow ' + ds.title, date: rollForward(new Date(lf.getTime())) });
        } else if (ds.gs === 'warm') {
            out.push({ label: 'Start ' + ds.title + ' indoors', date: rollForward(addDays(lf, -42)) });
        } else if (ds.gs === 'cool') {
            out.push({ label: 'Direct-sow ' + ds.title, date: rollForward(new Date(lf.getTime())) });
            out.push({ label: 'Fall sowing: ' + ds.title, date: rollForward(addDays(toDate(frost[1]), -56)) });
        } else {
            out.push({ label: 'Sow cool crops: ' + ds.title, date: rollForward(new Date(lf.getTime())) });
            out.push({ label: 'Start warm crops indoors: ' + ds.title, date: rollForward(addDays(lf, -42)) });
        }
        return out;
    }

    // Сколько дней до ближайшего действия по этому паку (null = действий нет)
    function daysUntilAction(zone, ds) {
        var dates = actionDates(zone, ds);
        if (!dates.length) return null;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var min = Infinity;
        dates.forEach(function (a) {
            var d = Math.round((a.date.getTime() - today.getTime()) / 86400000);
            if (d >= 0 && d < min) min = d;
        });
        return min === Infinity ? null : min;
    }

    // Релевантность именно этому садовнику: сеять скоро > комфортная зона > рейтинг
    function scoreFor(state, ds) {
        var s = 0;
        if (ds.gs === 'indoor') {
            s += 3; // микрозелень сеют когда угодно, значит и сейчас
        } else {
            var days = daysUntilAction(state.zone, ds);
            if (days !== null) {
                if (days <= 30) s += 3;
                else if (days <= 60) s += 1.5;
            }
        }
        // зона в середине диапазона = культуре комфортно, а не на грани выживания
        if (ds.zones) {
            var zs = ds.zones.split(',').map(function (z) { return parseInt(z, 10); })
                .filter(function (z) { return z; });
            if (zs.length) {
                var lo = Math.min.apply(null, zs), hi = Math.max.apply(null, zs);
                if (state.zone > lo && state.zone < hi) s += 1;
            }
        }
        s += (ds.rating / 5) * 2;
        if (ds.rcount > 100) s += 0.5;
        if (ds.beginner) s += 0.5;
        return s;
    }

    function cardData(card) {
        var d = card.dataset;
        return {
            zones: d.zones || '',
            sun: d.sun || '',
            space: d.space || '',
            gs: d.gs || 'any',
            life: d.life || '',
            goals: d.goals || '',
            beginner: d.beginner === '1',
            rating: parseFloat(d.rating) || 0,
            rcount: parseInt(d.rcount, 10) || 0,
            title: d.title || '',
            url: d.url || '',
            isSet: d.set === '1',
            price: parseFloat(d.price) || 0,
            varieties: parseInt(d.varieties, 10) || 0
        };
    }

    // Чипы целей упрощены: veg вбирает салаты и фрукты/бахчевые
    var GOAL_ALIAS = { veg: ['veg', 'salad', 'fruit'], herb: ['herb'], micro: ['micro'], flower: ['flower'] };

    function matches(state, ds) {
        // Зона: пустой список зон = растёт везде.
        // Выбран Indoors = зона не важна вовсе (дома климат одинаковый: травы,
        // микрозелень, cat grass растут в любой зоне).
        // В безморозных зонах (10+) hardiness-списки (кураторские до 10b) гейтят только
        // многолетники: однолетники растут там в свой прохладный сезон.
        if (ds.zones && state.space !== 'indoor') {
            var perennial = ds.life.indexOf('perennial') !== -1 && ds.life.indexOf('annual') === -1;
            if (FROST[state.zone] !== null || perennial) {
                var ok = ds.zones.split(',').some(function (z) { return parseInt(z, 10) === state.zone; });
                if (!ok) return false;
            }
        }
        // Свет
        if (state.light === 'sun') {
            if (ds.sun && ds.sun.indexOf('full') === -1) return false;
        } else if (state.light === 'part') {
            if (ds.sun && ds.sun.indexOf('part') === -1) return false;
        } else { // low / indoor: тенеустойчивость ИЛИ растёт дома; пустой sun не ограничивает
            var lowOk = !ds.sun || ds.sun.indexOf('shade') !== -1 ||
                ds.gs === 'indoor' || ds.space.indexOf('indoor') !== -1;
            if (!lowOk) return false;
        }
        // Место: Outdoors / Indoors
        if (state.space === 'outdoor') {
            if (ds.space && ds.space.indexOf('outdoor') === -1) return false;
        } else {
            if (ds.gs !== 'indoor' && ds.space.indexOf('indoor') === -1) return false;
        }
        // Цели: ничего не выбрано = всё подходит
        if (state.goals.length) {
            var hit = state.goals.some(function (g) {
                return (GOAL_ALIAS[g] || [g]).some(function (a) { return ds.goals.indexOf(a) !== -1; });
            });
            if (!hit) return false;
        }
        if (state.beginner && !ds.beginner) return false;
        return true;
    }

    function initSection(root) {
        if (root.dataset.sfReady) return;
        root.dataset.sfReady = '1';

        var grid = root.querySelector('[data-sf-grid]');
        var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sf-card]'));
        if (!grid || !cards.length) return;

        // Один раз сортируем по рейтингу и раскладываем: сеты в свою сетку, остальное в основную
        var setsGrid = root.querySelector('[data-sf-grid-sets]');
        var setsHead = root.querySelector('[data-sf-sets-head]');
        var setsSub = root.querySelector('[data-sf-sets-sub]');
        var singlesHead = root.querySelector('[data-sf-singles-head]');
        var resultsTitle = root.querySelector('[data-sf-results-title]');
        cards.sort(function (a, b) {
            var da = cardData(a), db = cardData(b);
            return (db.rating - da.rating) || (db.rcount - da.rcount);
        });
        cards.forEach(function (c) {
            (c.dataset.set === '1' ? setsGrid : grid).appendChild(c);
        });

        var zoneSel = root.querySelector('[data-sf-zone]');
        var zipInput = root.querySelector('[data-sf-zip]');
        var zipMsg = root.querySelector('[data-sf-zipmsg]');
        var beginnerCb = root.querySelector('[data-sf-beginner]');
        var totalEl = root.querySelector('[data-sf-total]');
        var countEl = root.querySelector('[data-sf-count]');
        var zoneLabel = root.querySelector('[data-sf-zone-label]');
        var frostEl = root.querySelector('[data-sf-frost]');
        var emptyEl = root.querySelector('[data-sf-empty]');
        var moreBtn = root.querySelector('[data-sf-more]');
        var expanded = false;

        var state = {
            zone: parseInt(root.dataset.defaultZone, 10) || 6,
            light: 'sun',
            space: 'outdoor',
            goals: [],
            beginner: false
        };
        zoneSel.value = String(state.zone);
        totalEl.textContent = cards.length;

        var visible = [];

        function apply() {
            visible = [];
            cards.forEach(function (card) {
                var ds = cardData(card);
                var show = matches(state, ds);
                card.hidden = !show;
                if (!show) return;
                visible.push(card);
                var t = timingFor(state.zone, ds);
                card.querySelector('[data-sf-timing]').innerHTML = t.html;
                card.querySelector('[data-sf-chip]').textContent = t.chip;
                card.querySelector('.or-sf-card__dot').setAttribute('data-dot', t.dot);

                // Скоринг под конкретного садовника + метка «сеять пора сейчас»
                card.dataset.score = scoreFor(state, ds);
                var days = ds.gs === 'indoor' ? 0 : daysUntilAction(state.zone, ds);
                card.querySelector('[data-sf-now]').hidden = !(days !== null && days <= 30);
            });

            // Лучшие совпадения первыми (скор → рейтинг)
            visible.sort(function (a, b) {
                return (parseFloat(b.dataset.score) - parseFloat(a.dataset.score)) ||
                    (cardData(b).rating - cardData(a).rating);
            });
            visible.forEach(function (c) {
                (c.dataset.set === '1' ? setsGrid : grid).appendChild(c);
            });
            // Группы: сеты сверху, индивидуальные пакеты ниже
            var setsVisible = visible.filter(function (c) { return c.dataset.set === '1'; });
            var singles = visible.filter(function (c) { return c.dataset.set !== '1'; });

            setsHead.hidden = setsVisible.length === 0;
            singlesHead.hidden = singles.length === 0;

            // «от $X за сорт» по самому выгодному видимому сету
            var perVariety = Infinity;
            setsVisible.forEach(function (c) {
                var ds2 = cardData(c);
                if (ds2.varieties > 0 && ds2.price > 0) {
                    perVariety = Math.min(perVariety, ds2.price / ds2.varieties);
                }
            });
            if (!setsSub.dataset.fallback) setsSub.dataset.fallback = setsSub.textContent;
            if (perVariety < Infinity && setsSub.dataset.template) {
                setsSub.textContent = setsSub.dataset.template
                    .replace('{price}', '$' + perVariety.toFixed(2));
            } else {
                setsSub.textContent = setsSub.dataset.fallback;
            }

            // Подбор = короткий список лучших, остальное по кнопке
            var setsCap = expanded ? Infinity : 4;
            var singlesCap = expanded ? Infinity : 12;
            setsVisible.forEach(function (card, i) { if (i >= setsCap) card.hidden = true; });
            singles.forEach(function (card, i) { if (i >= singlesCap) card.hidden = true; });

            var hiddenCount = Math.max(0, setsVisible.length - setsCap) +
                Math.max(0, singles.length - singlesCap);
            moreBtn.hidden = hiddenCount === 0;
            if (hiddenCount) moreBtn.textContent = 'Show ' + hiddenCount + ' more matches';

            var shown = Math.min(setsVisible.length, setsCap) + Math.min(singles.length, singlesCap);
            resultsTitle.textContent = visible.length === 0
                ? 'Your matches'
                : (hiddenCount ? 'Top ' + shown + ' picks for Zone ' + state.zone
                               : shown + ' picks for your Zone ' + state.zone + ' garden');

            countEl.textContent = visible.length;
            zoneLabel.textContent = 'Zone ' + state.zone;
            frostEl.textContent = FROST[state.zone] ? '~' + FROST[state.zone][0] : 'Frost-free';
            emptyEl.hidden = visible.length > 0;
        }

        // Смена любого фильтра сворачивает выдачу обратно до топа
        function applyReset() {
            expanded = false;
            apply();
        }
        moreBtn.addEventListener('click', function () {
            expanded = true;
            apply();
        });

        // --- фильтры ---
        function bindChips(sel, single, onPick) {
            var wrap = root.querySelector(sel);
            if (!wrap) return;
            wrap.addEventListener('click', function (e) {
                var chip = e.target.closest('.or-sf__chip');
                if (!chip) return;
                if (single) {
                    wrap.querySelectorAll('.or-sf__chip').forEach(function (c) { c.classList.remove('is-active'); });
                    chip.classList.add('is-active');
                } else {
                    chip.classList.toggle('is-active');
                }
                onPick(wrap);
                applyReset();
            });
        }
        bindChips('[data-sf-light]', true, function (w) { state.light = w.querySelector('.is-active').dataset.val; });
        bindChips('[data-sf-space]', true, function (w) { state.space = w.querySelector('.is-active').dataset.val; });
        bindChips('[data-sf-goals]', false, function (w) {
            state.goals = Array.prototype.map.call(w.querySelectorAll('.is-active'), function (c) { return c.dataset.val; });
        });
        beginnerCb.addEventListener('change', function () { state.beginner = beginnerCb.checked; applyReset(); });
        zoneSel.addEventListener('change', function () {
            state.zone = parseInt(zoneSel.value, 10);
            zipMsg.textContent = '';
            applyReset();
        });

        var resetBtn = root.querySelector('[data-sf-reset]');
        if (resetBtn) resetBtn.addEventListener('click', function () {
            root.querySelectorAll('[data-sf-goals] .is-active').forEach(function (c) { c.classList.remove('is-active'); });
            state.goals = [];
            state.beginner = false;
            beginnerCb.checked = false;
            applyReset();
        });

        // --- ZIP → зона (phzmapi.org, бесплатно). Ошибка = остаётся ручной селект ---
        var zipTimer;
        zipInput.addEventListener('input', function () {
            clearTimeout(zipTimer);
            var zip = zipInput.value.replace(/\D/g, '');
            zipInput.value = zip;
            if (zip.length !== 5) { zipMsg.textContent = ''; return; }
            zipTimer = setTimeout(function () {
                fetch('https://phzmapi.org/' + zip + '.json')
                    .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
                    .then(function (data) {
                        var z = parseInt(data.zone, 10);
                        if (!z) throw new Error('bad zone');
                        z = Math.min(11, Math.max(3, z));
                        state.zone = z;
                        zoneSel.value = String(z);
                        zipMsg.textContent = 'Zone ' + data.zone + ' detected ✓';
                        zipMsg.classList.remove('is-error');
                        applyReset();
                    })
                    .catch(function () {
                        zipMsg.textContent = 'ZIP not found. Pick your zone instead.';
                        zipMsg.classList.add('is-error');
                    });
            }, 400);
        });

        // --- email → Klaviyo + напоминания ---
        var form = root.querySelector('[data-sf-form]');
        var emailInput = root.querySelector('[data-sf-email]');
        var consentCb = root.querySelector('[data-sf-consent]');
        var msgEl = root.querySelector('[data-sf-msg]');
        var doneEl = root.querySelector('[data-sf-done]');
        var lastPlan = null;

        function planFromVisible() {
            var frost = FROST[state.zone];
            var packs = visible.map(function (c) { return cardData(c); });
            var reminders = [];
            packs.forEach(function (ds) {
                actionDates(state.zone, ds).forEach(function (a) {
                    reminders.push({ label: a.label, date: a.date, url: ds.url });
                });
            });
            reminders.sort(function (a, b) { return a.date - b.date; });
            return { packs: packs, reminders: reminders, lastFrost: frost ? frost[0] : 'none' };
        }

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            var email = emailInput.value.trim();
            msgEl.hidden = true;
            if (!/.+@.+\..+/.test(email)) {
                msgEl.textContent = 'Please enter a valid email address.';
                msgEl.hidden = false;
                return;
            }
            if (!consentCb.checked) {
                msgEl.textContent = 'Please tick the consent box so we can email your plan.';
                msgEl.hidden = false;
                return;
            }

            lastPlan = planFromVisible();
            var klaviyo = window.klaviyo = window.klaviyo || [];
            var profile = {
                '$email': email,
                'USDA Zone': state.zone,
                'Garden Goals': state.goals.length ? state.goals : ['all'],
                'Gardener Level': state.beginner ? 'new' : 'experienced'
            };
            if (lastPlan.reminders.length) {
                profile['Next Start Date'] = isoDay(lastPlan.reminders[0].date);
                profile['Planting Reminders'] = lastPlan.reminders.map(function (r) {
                    return isoDay(r.date) + ' ' + r.label;
                });
            }
            // нет дат (безморозная зона, одна микрозелень) — кнопке календаря нечего отдавать
            var icsToggle = root.querySelector('[data-sf-ics]');
            if (icsToggle) icsToggle.hidden = lastPlan.reminders.length === 0;
            klaviyo.push(['identify', profile]);

            // Подписка в список Klaviyo (double/single opt-in — по настройке списка).
            // Fire-and-forget: письмо с планом идёт по событию и не зависит от этого вызова
            var listId = root.dataset.klaviyoList;
            var companyId = root.dataset.klaviyoCompany;
            if (listId && companyId) {
                fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
                    body: JSON.stringify({
                        data: {
                            type: 'subscription',
                            attributes: {
                                custom_source: 'Seed Finder',
                                profile: { data: { type: 'profile', attributes: { email: email } } }
                            },
                            relationships: { list: { data: { type: 'list', id: listId } } }
                        }
                    })
                }).catch(function () {});
            }
            klaviyo.push(['track', 'Requested Seed Plan', {
                usda_zone: state.zone,
                last_frost: lastPlan.lastFrost,
                light: state.light,
                space: state.space,
                goals: state.goals,
                beginner: state.beginner,
                match_count: lastPlan.packs.length,
                matched_packs: lastPlan.packs.map(function (p) { return p.title; }),
                matched_pack_urls: lastPlan.packs.map(function (p) { return location.origin + p.url; }),
                // Топ-4 для блока товаров в письме (как в or-seed-quiz.js):
                // visible уже отсортирован по скору под садовника
                top_matches: visible.slice(0, 4).map(function (c) {
                    var ds = cardData(c);
                    var img = c.querySelector('.or-sf-card__img');
                    return {
                        title: ds.title,
                        url: location.origin + ds.url,
                        image: img && img.src ? img.src : '',
                        price: '$' + ds.price.toFixed(2)
                    };
                }),
                reminder_opt_in: true,
                reminders: lastPlan.reminders.map(function (r) {
                    return { pack: r.label, date: isoDay(r.date) };
                })
            }]);

            form.hidden = true;
            doneEl.hidden = false;
        });

        // --- .ics: событие на каждую дату посадки + напоминание за неделю ---
        var icsBtn = root.querySelector('[data-sf-ics]');
        if (icsBtn) icsBtn.addEventListener('click', function () {
            var plan = lastPlan || planFromVisible();
            if (!plan.reminders.length) return;
            var stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
            var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Organo Republic//Seed Finder//EN'];
            plan.reminders.forEach(function (r, i) {
                lines.push(
                    'BEGIN:VEVENT',
                    'UID:or-seed-finder-' + stamp + '-' + i + '@organorepublic.com',
                    'DTSTAMP:' + stamp,
                    'DTSTART;VALUE=DATE:' + icsDay(r.date),
                    'SUMMARY:' + icsEsc('🌱 ' + r.label),
                    'DESCRIPTION:' + icsEsc('Your Organo Republic planting plan: ' + location.origin + r.url),
                    'BEGIN:VALARM',
                    'TRIGGER:-P7D',
                    'ACTION:DISPLAY',
                    'DESCRIPTION:' + icsEsc(r.label),
                    'END:VALARM',
                    'END:VEVENT'
                );
            });
            lines.push('END:VCALENDAR');
            var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'organo-republic-planting-plan.ics';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(function () { URL.revokeObjectURL(a.href); }, 1000);
        });

        apply();
    }

    function initAll(scope) {
        (scope || document).querySelectorAll('[data-or-seed-finder]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
        initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
